module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (150).dcb5d782.jpg";